<template>
  <div id="assetList">
    <FilterFrame
      ref="filter"
      :filter-form="assetFilter"
      @search="onSearchValue('search')"
      @clear="clearSearch()"
      @onSearchValue="checkExportRule"
    />
    <div class="title_bar">
      <div class="left" />
      <div class="right">
        <el-button
          icon="icon-download"
          round
          @click="getExample"
        >
          下載預設表單
        </el-button>
        <el-button
          icon="icon-upload2"
          round
          @click="$refs.fileInput.click()"
        >
          匯入
        </el-button>
        <input
          ref="fileInput"
          style="display: none"
          type="file"
          @change="importAsset"
        >
        <el-button
          icon="icon-plus"
          round
          @click="goEdit('new', null)"
        >
          新增
        </el-button>
        <el-button
          icon="icon-delete"
          round
          @click="deleteAssets"
        >
          刪除
        </el-button>
        <el-dropdown
          trigger="click"
          @command="handleExportCommand"
        >
          <el-button
            icon="icon-output"
            round
          >
            匯出
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="excel">
              資產清冊
            </el-dropdown-item>
            <el-dropdown-item command="qrcode">
              QRcode
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-table
      class="newslist"
      :data="ListData"
      empty-text="目前無資產設備"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <el-table-column
        prop="AssetSn"
        label="設備財編"
      />
      <el-table-column label="設備名稱">
        <template slot-scope="scope">
          <span
            class="assetLink"
            @click="goEdit('view', scope.row.Id)"
          >{{ scope.row.AssetName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="設備類別">
        <template slot-scope="scope">
          {{ scope.row.CategoryId ? filterMainCategoryName(scope.row.CategoryId) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Status"
        label="設備狀態"
      >
        <template slot-scope="scope">
          {{ assetFilter[5].options.find(item => item.value === scope.row.StatusId)
            ? (assetFilter[5].options.find(item => item.value === scope.row.StatusId)).label
            : '' }}
        </template>
      </el-table-column>
      <el-table-column label="區域">
        <template slot-scope="scope">
          {{ assetFilter[1].options.find(item => item.value === scope.row.AreaId)
            ? (assetFilter[1].options.find(item => item.value === scope.row.AreaId)).label
            : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="BrandName"
        label="廠牌"
      />
      <el-table-column
        prop="ModelNo"
        label="型號"
      />
      <el-table-column
        prop="SupplierId"
        label="負責廠商"
      >
        <template slot-scope="scope">
          {{ assetFilter[4].options.find(item => item.value === scope.row.SupplierId)
            ? (assetFilter[4].options.find(item => item.value === scope.row.SupplierId)).label
            : '' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="goEdit('edit', scope.row.Id)"
          >
            編輯
          </el-button>
          <el-button
            v-if="scope.row.IsDeletable !== false"
            size="mini"
            type="danger"
            plain
            @click="deleteAsset(scope.row.Id)"
          >
            刪除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :page-size="maxCount"
      :total="listTotalCount"
      @current-change="getList"
    />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { getUrl } from '@/js/utils/url'
export default {
  components: {
    FilterFrame,
    TableLoading
  },
  data () {
    return {
      filter: {},
      assetFilter: [
        {
          label: '設備類別',
          name: 'category',
          type: 'cascader',
          options: [],
          value: ''
        },
        {
          label: '區域',
          name: 'area',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: '設備名稱',
          name: 'assetName',
          type: 'input',
          value: ''
        },
        {
          label: '財產編號',
          name: 'assetSn',
          type: 'input',
          value: ''
        },
        {
          label: '負責廠商',
          name: 'supplier',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: '設備狀態',
          name: 'status',
          type: 'multiselect',
          options: [],
          value: ''
        }
      ],
      loading: false,
      maxCount: 50,
      ListData: [],
      listTotalCount: 0,
      nowPage: 1,
      canClickButton: true,
      status: [],
      multipleSelection: [],
      originalCategoryList: []
    }
  },
  mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    this.getCategory()
    this.getArea()
    this.getSupplier()
    this.getStatus()
    this.getList()
  },
  activated () {
    this.getList()
  },
  methods: {
    // 取得資產類型
    getCategory () {
      apiAsset.Asset.GetCategory()
        .then(res => {
          console.log(res)
          this.originalCategoryList = res.data
          const mainCategory = this.assetFilter[0].options
          this.originalCategoryList.forEach(item => {
            if (!item.ParentId) {
              mainCategory.push({
                label: item.Name,
                value: item.Id,
                children: []
              })
            }
          })
          this.originalCategoryList.forEach(item => {
            if (item.ParentId && item.Name) {
              const index = mainCategory.findIndex(mainItem => mainItem.value === item.ParentId)
              mainCategory[index].children.push({
                label: item.Name,
                value: item.Id
              })
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    filterMainCategoryName (categoryId) {
      const category = this.originalCategoryList.find(item => item.Id === categoryId)
      if (!category) {
        return ''
      }
      if (category.ParentId) {
        const mainCategory = this.originalCategoryList.find(item => item.Id === category.ParentId)
        return mainCategory.Name
      } else {
        return category.Name
      }
    },
    // 取得社區位置
    getArea () {
      apiAsset.Asset.GetAreas()
        .then(res => {
          console.log(res)
          this.assetFilter[1].options = res.data.map(item => {
            return {
              label: item.Name,
              value: item.Id
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 取得廠商
    getSupplier () {
      return new Promise((resolve, reject) => {
        apiAsset.Asset.GetSuppliers()
          .then(res => {
            console.log(res)
            this.assetFilter[4].options = res.data.map(item => {
              return {
                label: item.SupplierName,
                value: item.SupplierId
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得廠商資料失敗'))
          })
      })
    },
    // 取得資產狀態
    getStatus () {
      apiAsset.Asset.GetStatus()
        .then(res => {
          console.log(res)
          this.assetFilter[5].options = res.data.map(item => {
            return {
              label: item.StatusDesc,
              value: item.Id
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 查詢
    search () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.ListData = []
        window.scrollTo(0, 0)
        this.getList()
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.filter = {}
        this.ListData = []
        this.loading = true
        window.scrollTo(0, 0)
        this.getList()
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    checkExportRule (such_val) {
      function filterCategoryId (category) {
        if (!category) return
        return category[1] ? category[1] : category[0]
      }
      this.filter = {
        'Filter.CategoryId': filterCategoryId(such_val.category),
        'Filter.AreaId': such_val.area ? such_val.area : undefined,
        'Filter.AssetName': such_val.assetName ? such_val.assetName : undefined,
        'Filter.AssetSn': such_val.assetSn ? such_val.assetSn : undefined,
        'Filter.SupplierId': such_val.supplier ? such_val.supplier : undefined,
        'Filter.StatusIds': such_val.status ? such_val.status : undefined
      }
    },
    getList (page = 1) {
      this.loading = true
      this.nowPage = page
      apiAsset.Asset.GetAssets({
        Offset: (page - 1) * this.maxCount,
        MaxCount: this.maxCount,
        ...this.filter
      }).then(res => {
        console.log(res)
        this.ListData = res.data.Data
        this.listTotalCount = res.data.Total
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    onSearchValue (type, event) {
      this.$refs.filter.onSearchValue()
      switch (type) {
        case 'search':
          this.search(event)
          break
        case 'export':
          this.exportAssets()
          break
        case 'qrcode':
          this.getQRcode()
          break
      }
    },
    exportAssets () {
      const config = {
        responseType: 'blob',
        params: this.multipleSelection.length ? { 'Filter.AssetIds': this.multipleSelection } : this.filter
      }
      apiAsset.Asset.GetExportExcelAsset(config).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${dayjs().format('YYYYMMDD')}資產清冊.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(err => {
        console.log(err)
      })
    },
    // 下載預設表單
    getExample () {
      apiAsset.Asset.GetExcelExample({
        responseType: 'blob'
      })
        .then(res => {
          console.log(res)
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', '資產設備匯入預設表單.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 匯入檔案
    importAsset (e) {
      const uploadFormData = new FormData()
      uploadFormData.append('File', e.target.files[0])
      apiAsset.Asset.PostImportExcelAsset(uploadFormData)
        .then(res => {
          console.log(res)
          this.$refs.fileInput.value = ''
          this.getList()
        })
        .catch(err => {
          if (err.response.data.ErrorCode === 400000) {
            this.$message({
              message: err.response.data.Messages[0],
              type: 'warning'
            })
          } else {
            this.$message({
              message: '上傳過程發生異常，請重新再[送出]一次',
              type: 'warning'
            })
          }
        })
    },
    deleteAsset (assetId) {
      this.$confirm('資產設備刪除後無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const params = {
            AssetId: assetId
          }
          apiAsset.Asset.DeleteAsset(params)
            .then(res => {
              console.log(res)
              this.$message({
                message: '刪除成功',
                type: 'success'
              })
              this.getList(this.nowPage)
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '刪除失敗',
                type: 'error'
              })
            })
        })
        .catch(() => {})
    },
    deleteAssets () {
      if (!this.multipleSelection.length) return
      this.$confirm('資產設備刪除後無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const params = {
            AssetIds: this.multipleSelection
          }
          apiAsset.Asset.DeleteAssets(params)
            .then(res => {
              console.log(res)
              this.$message({
                message: '刪除成功',
                type: 'success'
              })
              this.getList(this.nowPage)
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '刪除失敗',
                type: 'error'
              })
            })
        })
        .catch(() => {})
    },
    goEdit (type, assetId) {
      if (type === 'new') {
        this.$router.push({ name: 'assetEdit' })
      } else if (type === 'edit') {
        this.$router.push({ name: 'assetEdit', query: { assetId } })
      } else {
        this.$router.push({ name: 'assetEdit', query: { assetId, pageType: 'view' } })
      }
    },
    handleExportCommand (command) {
      if (command === 'excel') {
        this.onSearchValue('export')
      } else if (command === 'qrcode') {
        this.onSearchValue('qrcode')
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val.map(item => item.Id)
    },
    getQRcode () {
      this.loading = true
      if (this.multipleSelection.length) {
        const assetUrlList = this.multipleSelection.map(item => {
          return {
            name: (this.ListData.find(listItem => listItem.Id === item)).AssetName,
            url: getUrl('mgmt', `asset/assetEdit?pageType=view&assetId=${item}`)
          }
        })
        console.log(assetUrlList)
        this.$store.commit('SET_ASSET_URL_LIST', assetUrlList)
        this.$router.push('/asset/assetQRcode')
      } else {
        apiAsset.Asset.GetAssets({
          Offset: 0,
          MaxCount: this.listTotalCount,
          ...this.filter
        }).then(res => {
          this.loading = false
          console.log(res)
          const assetUrlList = res.data.Data.map(item => {
            return {
              name: item.AssetName,
              url: getUrl('mgmt', `asset/assetEdit?pageType=view&assetId=${item.Id}`)
            }
          })
          this.$store.commit('SET_ASSET_URL_LIST', assetUrlList)
          this.$router.push('/asset/assetQRcode')
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#assetList
  text-align: center
  padding: 20px 0 10px
  height: 100%
  .title_bar
    .right button
      margin-left: 16px
    display: flex
    justify-content: space-between
    align-items: center
    margin: 20px 0
  .title_bar.center
    margin: 20px 0 10px 0
  .newslist
    font-size: 15px
    ::v-deep .el-table
      +basicTable
    .noWordBreak
      word-wrap: break-word
    .status
      color: $subFontColor
    .status-danger
      color: $dangerColor
    .assetLink
      color: $mainColorDark
      cursor: pointer
      text-decoration: underline

  .el-pagination
    display: flex
    justify-content: flex-start
    margin-top: 28px
</style>
